module.exports = __webpack_public_path__ + "img/baidu.81f10e05.png";